import RegisterService from "../../services/authentication-service";
import ChangePasswordModel from "../../models/authentication/ChangePasswordModel";
import { PASSWORD_RULE } from "../../utils/validation-utils";
import { useForm } from "react-hook-form";
import EncryptUtil from '../../utils/encode-utils';
import toasterUtils from "../../utils/toaster-utils";
import { useAppDispatch, useAppSelector } from "../../context-store";
import modalUtils from "../../utils/modal-utils";
import loaderUtils from "../../utils/loader-utils";
import authenticationService from "../../services/authentication-service";
import { authActions } from "../../context-store/auth-context";
import { useHistory } from "react-router";
import { Button, FormControl, TextField } from "@mui/material";

const ChangePasswordComponent = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<ChangePasswordModel>({
        mode: "onChange",
    });

    const onSubmit = (formData: ChangePasswordModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.password = EncryptUtil.getEncoded(formData.password);
        formData.newPassword = EncryptUtil.getEncoded(formData.newPassword);
        formData.confirmNewPassword = EncryptUtil.getEncoded(formData.confirmNewPassword);
        if (formData.newPassword != formData.confirmNewPassword) {
            toasterUtils.showError("New passwords doesn't match.");
        } else {
            if (loggedInUser != null) {
                formData.userId = loggedInUser.userId;
                modalUtils.showLoader();
                RegisterService.ChangePassword(formData).then((res) => {
                    modalUtils.closeModal();
                    if (!res.isSuccess || res.errorMessages.length > 0) {
                        toasterUtils.showError(res.errorMessages.toString());
                        return;
                    }
                    toasterUtils.showSuccess(res.informationMessages.toString());
                    setTimeout(() => {
                        logOutHandler();
                    }, 2000);
                }).catch((error) => {
                    modalUtils.closeModal();
                    toasterUtils.showError("Erorr registering user.");
                });
            }
        }
    };

    const logOutHandler = () => {
        authenticationService.logOut().then(() => {
            dispatch(authActions.logout());
            history.push("/login");
        }).catch(error => {
            toasterUtils.showError('Unable to logout user!');
        });
    }

    return (
        <section className="bg-light">
                <div className="card card-white">                    
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3"></div>
                            <div className="col-md-6">
                                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <FormControl fullWidth margin="normal" error={!!errors.password}>
                                                <TextField label="Existing Password" type="password" size="small"
                                                    {...register("password", { required: "Existing password is required" })} error={!!errors.password} helperText={errors.password?.message} placeholder="Existing Password" autoComplete="off" required />
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <FormControl fullWidth margin="normal" error={!!errors.newPassword}>
                                                <TextField label="New Password" type="password" size="small"
                                                    {...register("newPassword", PASSWORD_RULE)} error={!!errors.newPassword} helperText={errors.newPassword?.message} placeholder="New Password" autoComplete="off" required />
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <FormControl fullWidth margin="normal" error={!!errors.confirmNewPassword}>
                                                <TextField label="Confirm New Password" type="password" size="small"
                                                    {...register("confirmNewPassword", PASSWORD_RULE)} error={!!errors.confirmNewPassword} helperText={errors.confirmNewPassword?.message} placeholder="Confirm New Password" autoComplete="off" required />
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="quform-submit-inner">
                                                <Button variant="contained" color="primary" type="submit" disabled={!isValid}>
                                                    Change Password
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-3"></div>
                        </div>
                    </div>
                </div>
        </section >
    );
};
export default ChangePasswordComponent;